import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewAttachIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="viewAttach" ref={ref} {...props}>
      <path d="M16.89,3.25H7.1A3.76,3.76,0,0,0,3.35,7V17A3.76,3.76,0,0,0,7.1,20.75h9.79A3.75,3.75,0,0,0,20.64,17V7A3.75,3.75,0,0,0,16.89,3.25Zm-9.79,16A2.25,2.25,0,0,1,4.85,17V7A2.25,2.25,0,0,1,7.1,4.75h9.79A2.25,2.25,0,0,1,19.14,7v4.37a8.66,8.66,0,0,0-7.86,7.88Zm12-2.25a2.25,2.25,0,0,1-2.25,2.25h-4.1a7.14,7.14,0,0,1,6.35-6.37Z" />
    </Icon>
  ),
) as IconWithRender;

ViewAttachIcon.displayName = 'ViewAttachIcon';
ViewAttachIcon.renderIcon = (props) => <ViewAttachIcon {...props} />;
export default ViewAttachIcon;
